module.exports = __webpack_public_path__ + "static/media/3 13 Tulleord Starter testen.43dec3fb.m4a";